<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="card-title"
    :class="cn('cn-font-heading text-sm font-bold group-data-[size=sm]/card:text-sm', props.class)"
  >
    <slot />
  </div>
</template>
